export default __webpack_public_path__ + "header-image-960-7d1323dfbdaf46b8dcf4109400069057.webp";